import type { Review } from "@/data/reviewTypes";

export const DALLAS_REVIEWS: Review[] = [
  { name: "Miguel K.", initials: "MK", rating: 5, date: "1 week ago", text: "DFW curbside pickup for a 14-person crew to AT&T Stadium. Sprinter was spotless, driver knew every Dallas shortcut. Booking again." },
  { name: "Sara R.", initials: "SR", rating: 5, date: "3 weeks ago", text: "Bachelorette weekend around Downtown Dallas. Easy delivery to our hotel, captain's chairs, cold AC even in Dallas heat. Perfect." },
  { name: "Devon T.", initials: "DT", rating: 5, date: "1 month ago", text: "Booked the 15-passenger for Dallas game day. On-time, full tank, no surprise charges. Best van rental in North Texas." },
];
